import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TCN } from '../../tcn/ui-kit/tokens';

/**
 * Shared entry segment under the bottom "Creators" tab.
 *
 * The bottom nav has a single "Creators" tab that fans out to two screens
 * (audit §0.2, validated with the client):
 *   - Creators      → Module 4 (individual roster) — /tcn/me/creators
 *   - New creators  → Module 2 (onboarding + pipeline) — /tcn/me/new-creators
 *
 * Rendered at the top of both pages so the user can hop between them without
 * leaving the tab. `active` = 'creators' | 'new'.
 */
const CreatorsSectionTabs = ({ active, isDesktop = false }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const segs = [
    { key: 'creators', label: t('tcn.creatorsTabs.creators', 'Creators'), to: '/tcn/me/creators' },
    { key: 'new', label: t('tcn.creatorsTabs.new', 'New creators'), to: '/tcn/me/new-creators' },
  ];

  return (
    <div
      style={{
        display: 'flex',
        gap: 4,
        padding: 4,
        background: TCN.surface1,
        border: `1px solid ${TCN.border}`,
        borderRadius: 12,
        alignSelf: isDesktop ? 'flex-start' : 'stretch',
      }}
    >
      {segs.map((s) => {
        const on = active === s.key;
        return (
          <button
            key={s.key}
            type="button"
            onClick={() => {
              if (!on) navigate(s.to);
            }}
            aria-current={on ? 'page' : undefined}
            style={{
              flex: isDesktop ? '0 0 auto' : 1,
              minWidth: isDesktop ? 130 : undefined,
              padding: '8px 14px',
              borderRadius: 9,
              border: 'none',
              cursor: on ? 'default' : 'pointer',
              fontFamily: 'inherit',
              fontSize: 13,
              fontWeight: 600,
              background: on ? TCN.surface3 : 'transparent',
              color: on ? TCN.text : TCN.textDim,
            }}
          >
            {s.label}
          </button>
        );
      })}
    </div>
  );
};

export default CreatorsSectionTabs;
